import { Directive, ElementRef, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core'
import { ConfirmationService } from 'primeng/api'
import { FormControl } from '@angular/forms'

@Directive()
export abstract class InlineEditCellNewDirective implements OnChanges {
  @Input() fieldName: string
  @Input() value: any
  @Input() editable: boolean
  @Input() mandatory: boolean
  @Input() customEdit = false
  @Input() minWidthPx = 70

  @Output() completeCellEdit: EventEmitter<any> = new EventEmitter()
  @Output() onCustomEdit: EventEmitter<any> = new EventEmitter()

  newValue: any | FormControl | undefined
  originalContent: Object

  // a flag for the derived classes to either show the cell in edit or read mode
  isEdited = false

  private confirmationService = inject(ConfirmationService)

  // needed for overlay input (if cells with is too narrow
  private el = inject(ElementRef)

  abortCellEdit(event) {
    this.isEdited = false
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.editable === undefined && !changes.editable) {
      this.editable = true
    }
    this.isEdited = false
    this.originalContent = null
  }

  onDelete(onAccept?: Function) {
    this.confirmationService.confirm({
      message: 'Sind Sie sicher, dass Sie dieses Feld leeren wollen?',
      header: 'Feld leeren',
      key: 'global',
      accept: () => {
        // new refactored components wrap input controls in a formControl. Resetting the value happens with reset().
        // old components hold the value directly and just need to be set to undefined
        if (this.newValue instanceof FormControl) {
          this.newValue.reset()
        } else {
          this.newValue = undefined
        }
        this.completeCellEdit.emit({ value: null })
        if (!!onAccept) {
          onAccept()
        }
      }
    })
  }

  onEdit() {
    if (this.customEdit) {
      this.onCustomEdit.emit()
    } else {
      this.triggerEdit()
    }
  }

  showInputAsOverlay(minWidthPx: number): boolean {
    const parentElement = <HTMLElement>this.el.nativeElement.parentElement
    const availableWidthPx = parentElement.getBoundingClientRect().width
    return availableWidthPx < minWidthPx
  }

  abstract triggerEdit(): void
}
